export default (state={}, action) => {
  switch (action.type) {
    case 'modal':
      return {
        modal: action.payload
      };
    default:
      return state;
  }
};